<script>
	import { createEventDispatcher } from "svelte";

	export let index;
	export let price;
	export let day;
	export let time;
	export let storedHours;

	const dispatch = createEventDispatcher();

	let hours;
	let minutes;

	if (storedHours) {
		hours = Math.floor(storedHours);
		minutes = Math.round((storedHours % 1) * 60);
	}

	$: if (minutes >= 60) {
		hours += 1;
		minutes = 0;
	}

	function handleChange() {
		hours = hours ? hours : 0;
		minutes = minutes ? minutes : 0;

		const totalHours = (hours * 60 + minutes) / 60;
		const totalPrice = totalHours * price;

		dispatch("add-row-info", {
			index: index,
			day: day,
			time: time,
			hours: totalHours,
			price: totalPrice,
		});
	}
</script>

<div class="psl-container">
	<div class="input-wrapper input-wrapper--hours">
		<label class="screen-reader-text" for={`hours-input-${index}`}
			>Tunnit</label
		>
		<input
			id={`hours-input-${index}`}
			class="psl-input hours"
			type="number"
			step="1"
			min="0"
			max="168"
			bind:value={hours}
			placeholder={0}
			on:change={handleChange}
		/>
	</div>
	<div class="input-wrapper input-wrapper--minutes">
		<label class="screen-reader-text" for={`minutes-input-${index}`}
			>Minuutit</label
		>
		<input
			id={`minutes-input-${index}`}
			class="psl-input minutes"
			type="number"
			step="10"
			min="0"
			max="60"
			bind:value={minutes}
			placeholder={0}
			on:change={handleChange}
		/>
	</div>
</div>

<style>
	.psl-container {
		display: flex;
	}

	.hours {
		border-radius: var(--border-radius-small);
	}

	.minutes {
		width: 140px;
		border-radius: 0 var(--border-radius-small) var(--border-radius-small) 0;
		border-left: 0;
		padding-right: 4rem;
	}

	.input-wrapper {
		position: relative;
	}

	.input-wrapper--minutes {
		display: none;
	}

	.input-wrapper:after {
		font-size: 1rem;
		font-weight: 500;
		position: absolute;
		right: 2px;
		top: 2px;
		z-index: 1;
		height: calc(100% - 4px);
		border-radius: 0 var(--border-radius-small) var(--border-radius-small) 0;
		border-left: 2px solid var(--color-blue);
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: var(--color-gray);
	}

	@media (min-width: 600px) {
		.hours {
			width: 130px;
			border-radius: var(--border-radius-small) 0 0
				var(--border-radius-small);
			padding-right: 3.5rem;
		}

		.input-wrapper--minutes {
			display: block;
		}

		.input-wrapper--hours:after {
			content: "h";
			width: 2.5rem;
		}
	}

	.input-wrapper--minutes:after {
		content: "min";
		width: 3rem;
	}
</style>
